import { ContributorsGridView } from '~/components/contributors/list/contributors-grid';
import { PageContainer } from '~/components/page-container';

export function ContributorsList() {
	return (
		<PageContainer>
			<ContributorsGridView />
		</PageContainer>
	);
}
